import { useEffect, useState } from 'react';
import { planoCliente, herdarReferencial, atualizarContaCliente } from '../api';
import { PageHeader, Loading, Empty, Alert } from '../components/common';
import NovaConta from '../components/NovaConta';

export default function PlanoContas({ clienteId }) {
  const [contas, setContas] = useState([]);
  const [todas, setTodas] = useState([]);   // plano inteiro, sem filtro: base da conta nova
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [tipo, setTipo] = useState('');
  const [msg, setMsg] = useState(null);
  const [novaAberta, setNovaAberta] = useState(false);
  const [renomeando, setRenomeando] = useState(null);   // { id, nome }

  const carregar = () => {
    if (!clienteId) return;
    setLoading(true);
    const filtros = {};
    if (busca) filtros.q = busca;
    if (tipo) filtros.tipo = tipo;
    planoCliente(clienteId, filtros)
      .then(r => setContas(r.items || []))
      .catch(err => setMsg({ tipo: 'danger', txt: err.message }))
      .finally(() => setLoading(false));
    planoCliente(clienteId, {})
      .then(r => setTodas(r.items || []))
      .catch(() => {});
  };

  useEffect(carregar, [clienteId, busca, tipo]);

  const herdar = async () => {
    if (!confirm('Copiar todas as contas do plano referencial Átrio para este cliente?')) return;
    try {
      const r = await herdarReferencial(clienteId);
      setMsg({ tipo: 'success', txt: `${r.inseridas} contas inseridas (já tinha ${r.antes})` });
      carregar();
    } catch (err) {
      setMsg({ tipo: 'danger', txt: err.message });
    }
  };

  const salvarNome = async () => {
    const nome = (renomeando?.nome || '').trim();
    if (nome.length < 2) return;
    try {
      const c = await atualizarContaCliente(clienteId, renomeando.id, { nome });
      setMsg({ tipo: 'success', txt: `Conta ${c.codigo} renomeada para "${c.nome}"` });
      setRenomeando(null);
      carregar();
    } catch (err) {
      setMsg({ tipo: 'danger', txt: err.message });
    }
  };

  if (!clienteId) return <Empty title="Selecione um cliente" />;

  return (
    <>
      <PageHeader
        title="Plano de contas"
        sub={`${contas.length} conta(s) no plano deste cliente`}
        actions={
          <>
            <button onClick={() => setNovaAberta(v => !v)}>+ Nova conta</button>
            <button onClick={herdar}>↓ Herdar referencial Átrio</button>
          </>
        }
      />
      {msg && <Alert tipo={msg.tipo}>{msg.txt}</Alert>}

      {novaAberta && (
        <NovaConta
          clienteId={clienteId}
          contas={todas}
          onFechar={() => setNovaAberta(false)}
          onCriada={(c) => {
            setNovaAberta(false);
            setMsg({ tipo: 'success', txt: `Conta ${c.codigo} · ${c.nome} criada` });
            carregar();
          }}
        />
      )}

      <div className="toolbar">
        <input placeholder="Buscar código ou nome…" value={busca} onChange={e => setBusca(e.target.value)} />
        <select value={tipo} onChange={e => setTipo(e.target.value)}>
          <option value="">Todos os tipos</option>
          <option value="S">Sintética</option>
          <option value="A">Analítica</option>
        </select>
      </div>

      <div className="card">
        {loading ? <Loading /> : contas.length === 0 ? (
          <Empty title="Sem contas" sub="Clique em 'Herdar referencial' pra copiar o plano padrão." />
        ) : (
          <table className="data">
            <thead>
              <tr>
                <th style={{ width: 140 }}>Código</th>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Natureza</th>
                <th>Nível</th>
              </tr>
            </thead>
            <tbody>
              {contas.map(c => (
                <tr key={c.id}>
                  <td style={{ paddingLeft: 10 + (c.nivel || 1) * 6, fontFamily: 'monospace', fontSize: 11 }}>
                    {c.codigo}
                  </td>
                  <td className={c.tipo === 'S' ? 'bold' : ''}>
                    {renomeando?.id === c.id ? (
                      <span>
                        <input value={renomeando.nome} aria-label={`Novo nome da conta ${c.codigo}`}
                          onChange={e => setRenomeando({ id: c.id, nome: e.target.value })}
                          onKeyDown={e => { if (e.key === 'Enter') salvarNome(); if (e.key === 'Escape') setRenomeando(null); }}
                          style={{ minWidth: 280 }} />
                        {' '}<button className="small" onClick={salvarNome}>Salvar</button>
                        {' '}<button className="small" onClick={() => setRenomeando(null)}>Cancelar</button>
                      </span>
                    ) : (
                      <>
                        {c.nome}
                        {' '}<a href="#" className="small muted" title="Renomear a conta"
                          onClick={e => { e.preventDefault(); setRenomeando({ id: c.id, nome: c.nome }); }}>renomear</a>
                      </>
                    )}
                  </td>
                  <td>
                    <span className={`badge badge--${c.tipo === 'S' ? 'info' : 'neutral'}`}>
                      {c.tipo === 'S' ? 'Sintética' : 'Analítica'}
                    </span>
                  </td>
                  <td>{c.natureza === 'D' ? '🔻 Devedora' : c.natureza === 'C' ? '🔺 Credora' : '—'}</td>
                  <td>{c.nivel}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
